import script from "./UserRoleForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserRoleForm.vue?vue&type=script&setup=true&lang=ts"

import "./UserRoleForm.vue?vue&type=style&index=0&id=23f707a6&scooped=true&lang=css"

const __exports__ = script;

export default __exports__